import { equals, find } from '@execonline-inc/collections';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import {
  ExperienceResource,
  ExperienceResourceArray,
} from '../../../../../CurrentCollectionStep/BuilderV2/Types';
import { previewStore } from '../../../../LearningCollectionPreviewStore';
import ExperienceCard from './ExperienceCard';
import ExperienceSection from './ExperienceSection';
import NoExperiences from './NoExperiences';
import { emptyFragment } from '@execonline-inc/execonline-ui';
import RefreshingSpinner from './RefreshingSpinner';

export interface Props {
  experiencesArray: ExperienceResourceArray;
}

function DefaultSection({ experiencesArray }: Props) {
  const { state } = previewStore;

  if (state.kind === 'waiting' || state.kind === 'loading') {
    return <RefreshingSpinner />;
  }
  if (
    state.kind === 'error' ||
    state.kind === 'save-celebration' ||
    state.kind === 'publish-celebration' ||
    state.kind === 'discarding-changes'
  ) {
    return emptyFragment();
  } else {
    const { name, description, experiences } = state.resource.payload.default_product_collection;
    return (
      <ExperienceSection name={name} description={description}>
        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
          {fromEmpty(experiences)
            .map((experiences) => (
              <>
                {experiences.map((ex) => {
                  const experienceResource = find(
                    (resource: ExperienceResource) => equals(resource.payload.id, ex),
                    experiencesArray,
                  );
                  return <ExperienceCard key={ex} experienceResource={experienceResource} />;
                })}
              </>
            ))
            .getOrElse(() => (
              <NoExperiences />
            ))}
        </div>
      </ExperienceSection>
    );
  }
}

export default observer(DefaultSection);
